import React from 'react';
import type { AppState } from '../types';
import { PageShell, glassLight, luxEstado, EmptyState, T } from '../ui';
export function Historial({
  state
}: {
  state: AppState;
}) {
  const sorted = [...state.meds].sort((a, b) => b.fecha - a.fecha);
  return <PageShell title="Historial" sub="Línea de tiempo de mediciones registradas" data-id="element-569">
      <style data-id="element-570">{`
        .hist-item {
          display: flex;
          gap: 16px;
          align-items: flex-start;
          padding: 14px 0;
          border-bottom: 1px solid ${T.border};
        }
        .hist-item:last-child { border-bottom: none; }
        .hist-list > * { animation: fadeUp .3s ease both; }
      `}</style>

      {sorted.length === 0 ? <EmptyState title="Sin registros aún" hint="Las mediciones que registres aparecerán aquí en orden cronológico." icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" data-id="element-572">
              <circle cx="12" cy="12" r="9" data-id="element-573" />
              <polyline points="12 6 12 12 16 14" data-id="element-574" />
            </svg>} data-id="element-571" /> : <div className="hist-list" style={{
      ...glassLight,
      padding: '8px 20px'
    }} data-id="element-575">
          {sorted.map((m, i) => {
        const suc = state.sucs.find(s => s.id === m.sucursalId);
        const est = luxEstado(m.lux, state.prefs.luxMin);
        return <div key={m.id} className="hist-item" data-id="element-576">
                {/* dot */}
                <div style={{
            flexShrink: 0,
            paddingTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }} data-id="element-577">
                  <div style={{
              width: 11,
              height: 11,
              borderRadius: '50%',
              background: est.color,
              boxShadow: `0 0 8px ${est.color}`
            }} data-id="element-578" />
                  {i < sorted.length - 1 && <div style={{
              width: 1,
              flex: 1,
              background: T.border,
              marginTop: 6
            }} data-id="element-579" />}
                </div>

                <div style={{
            flex: 1,
            minWidth: 0
          }} data-id="element-580">
                  <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 8
            }} data-id="element-581">
                    <div data-id="element-582">
                      <div style={{
                  fontWeight: 600,
                  color: T.text,
                  fontSize: 13
                }} data-id="element-583">
                        {m.punto}
                      </div>
                      <div style={{
                  fontSize: 12,
                  color: T.textSecondary,
                  marginTop: 2
                }} data-id="element-584">
                        {suc?.nombre ?? '—'}
                        {m.notas ? ` · ${m.notas}` : ''}
                      </div>
                    </div>
                    <div style={{
                textAlign: 'right',
                flexShrink: 0
              }} data-id="element-585">
                      <div style={{
                  fontWeight: 800,
                  color: est.color,
                  fontSize: 15,
                  lineHeight: 1
                }} data-id="element-586">
                        {m.lux} lx
                      </div>
                      <div style={{
                  fontSize: 11,
                  color: T.textMuted,
                  marginTop: 3
                }} data-id="element-587">
                        {new Date(m.fecha).toLocaleString('es-DO', {
                    day: '2-digit',
                    month: 'short',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
      })}
        </div>}
    </PageShell>;
}